<template>
  <div>
    <navBar />
    <div class="w-[1330px] mx-auto mt-14 px-12 pt-10 pb-12 bg-white rounded-lg">
      <p class="text-xl font-medium">token计费规则</p>
      <p class="pt-8 text-blue">基础消耗参考</p>
      <p class="pt-5">1、中文，1000个汉字，大约需消耗1200个token；</p>
      <p class="">2、English, 1000 tokens is about 750 words;</p>
      <p class="">3、以上数据是云从官方建议及第三方测试经验总结，一切以每次问答的实际消耗为准。</p>
      <p class="pt-11 text-blue">账号token消耗计算规则</p>
      <table class="mt-5 w-full table-auto">
        <thead class="h-14 bg-[#F0F4FF]">
          <tr>
            <th>产品类型</th>
            <th>模型</th>
            <th>输入消耗</th>
            <th>输出消耗</th>
            <th>上下文长度</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody class="text-center">
          <!-- <tr class="h-20 bg-[#FAFBFC]">
            <td>GPT-3.5 标准</td>
            <td>gpt-3.5-turbo</td>
            <td>基础消耗</td>
            <td>基础消耗</td>
            <td>4K context</td>
            <td>默认gpt-3.5-turbo-0613</td>
          </tr>
          <tr class="h-20 bg-[#F5F6F8]">
            <td>GPT-3.5 长文</td>
            <td>gpt-3.5-turbo-16K</td>
            <td>基础消耗*2</td>
            <td>基础消耗*2</td>
            <td>16K context</td>
            <td>默认gpt-3.5-turbo-16k-0613</td>
          </tr>
          <tr class="h-20 bg-[#FAFBFC]">
            <td>GPT-4 标准</td>
            <td>gpt-4</td>
            <td>基础消耗*20</td>
            <td>基础消耗*30</td>
            <td>8K context</td>
            <td>默认gpt-4-0613</td>
          </tr> -->
          <tr class="h-20 bg-[#FAFBFC]">
            <td>云从大模型</td>
            <td>Mass模型</td>
            <td>基础消耗</td>
            <td>基础消耗</td>
            <td>4K context</td>
            <td>默认模型</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import navBar from '@/components/navBar.vue'
</script>
